import { DetailValue } from 'components/common'
import { getDetailUrl } from 'models/Event/api'


const EventValue = ({ detail, asLink, isBack }) => {
  return (
    <DetailValue
      url={asLink && getDetailUrl(detail)}
      isBack={isBack}
      className="flex"
      render={() => (
        <>
          {detail?.name || '-'}
        </>
      )}
    />
  );
};


export default EventValue
